<template>
  <div id="InfoProgram">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">

      <div style="width:100%; padding:5px">
      <!-- <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeDialog(0)">Zamknij</md-button> -->
      <button class="btn btn-default" @click="closeDialog(0)"
      style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff">{{$t('message.close')}}</button>
      </div>
      <md-dialog-title>{{$t('message.address')}}</md-dialog-title>
      <div id="content">

        <form>
          <div class="wiersz">

            <div class="kolumny">
              <h5>{{$t('message.company_contracting')}}:</h5>
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.company_name')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa"
                v-model.lazy="zamawiajacy.nazwa">
              </div>
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.address_title')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="zamawiajacy.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.city')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="zamawiajacy.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="zamawiajacy.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefon" class="col-form-label">{{$t('message.phone')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefon"
                v-model.lazy="zamawiajacy.tel">
              </div>
              <div class="form-grupa">
                <label for="inputMail" class="col-form-label">{{$t('message.eMail')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputMail"
                v-model.lazy="zamawiajacy.email">
              </div>
              <div class="form-grupa">
                <label for="inputNIP" class="col-form-label">{{$t('message.nip')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputNIP"
                v-model.lazy="zamawiajacy.nip">
              </div>
            </div>

            <div class="kolumny">
              <h5>{{$t('message.investment')}} / {{$t('message.address_shipping')}}</h5>
              <div class="form-grupa">
                <label for="staticNazwaInwest" class="col-form-label">{{$t('message.investment_name')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwaInwest"
                v-model.lazy="inwestycja.nazwa">
              </div>
              <!-- <div class="form-grupa">
                <label for="inputBiuro" class="col-form-label">Nazwa biura projektowego / projektanta:</label>
                <br>
                <input type="text" class="form-control form-control-sm" id="inputBiuro"
                v-model.lazy="inwestycja.biuro_projektant">
              </div> -->
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.address')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="inwestycja.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.city')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="inwestycja.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="inwestycja.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefonKontakt" class="col-form-label">{{$t('message.phone_contact')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefonKontakt"
                v-model.lazy="inwestycja.tel">
              </div>
              <div class="form-grupa">
                <label for="inputMailKontakt" class="col-form-label">{{$t('message.email_contact')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputMailKontakt"
                v-model.lazy="inwestycja.email">
              </div>
            </div>

          </div>

          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="innyAdres" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">
              {{$t('message.check_other_address')}}
            </label>
          </div>

          <div class="wiersz" style="height:165px" v-if="innyAdres">

            <div class="kolumny">
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.company_name')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa"
                v-model.lazy="wysylka.nazwa">
              </div>
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.name_surname')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="wysylka.imie_nazwisko">
              </div>
            </div>
            <div class="kolumny">
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.address_shipping')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres"
                v-model.lazy="wysylka.adres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.city')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;"
                v-model.lazy="wysylka.kod_miasta">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;"
                v-model.lazy="wysylka.miasto">
              </div>
              <div class="form-grupa">
                <label for="inputTelefon" class="col-form-label">{{$t('message.phone')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefon"
                v-model.lazy="wysylka.tel">
              </div>
            </div>

          </div>

          <hr style="width: 450px;">
          <button class="btn btn-primary" @click.prevent="saveForm" style="float: right; margin: 10px 34px;">{{$t('message.save_form')}}</button>
          <button class="btn btn-warning" @click.prevent="clearForm" style="float: right; margin: 10px 34px;">{{$t('message.clear_form')}}</button>

        </form>

      </div>
    </md-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'DaneAdresowe',
  props: ['showDialog'],
  mixins: [app],
  data () {
    return {
      innyAdres: false,
      zamawiajacy: {
        nazwa: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: '',
        nip: ''
      },
      inwestycja: {
        nazwa: '',
        biuro_projektant: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: ''
      },
      wysylka: {
        nazwa: '',
        imie_nazwisko: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: ''
      }
    }
  },
  computed: {
    // ...mapGetters('app', ['config']),
    // ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs'])
  },
  watch: {
    outputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        // console.log(newValue)
        // this.zamawiajacy = newValue.zamawiajacy
        // this.inwestycja = newValue.inwestycja
        // this.wysylka = newValue.wysylka
        // Object.keys(this.inputData).forEach(element => {
        //   console.log(element)
        //   // this.inputData[element]['value'] = newValue[element].value
        // })
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    saveForm () {
      // console.log(this.zamawiajacy)
      // console.log(this.inwestycja)
      // console.log(this.innyAdres)
      // console.log(this.wysylka)

      this.changeValueOutputs('zamawiajacy', 'array', this.zamawiajacy)
      this.changeValueOutputs('inwestycja', 'array', this.inwestycja)
      if (this.innyAdres) {
        this.changeValueOutputs('wysylka', 'array', this.wysylka)
      }
      this.$emit('clickedClose', false)
    },
    clearForm () {
      this.zamawiajacy = {
        nazwa: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: '',
        nip: ''
      }
      this.inwestycja = {
        nazwa: '',
        biuro_projektant: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: '',
        email: ''
      }
      this.wysylka = {
        nazwa: '',
        imie_nazwisko: '',
        adres: '',
        kod_miasta: '',
        miasto: '',
        tel: ''
      }
      this.$store.commit('app/CLEAR_ADDRESS')
    }
  }
}
</script>

<style scoped>
.row {
  margin: 15px;
}
.wiersz {
  width: 100%;
  height: 400px;
  padding: 0px 15px;
  display: inline-flex;
}
.kolumny{
  width:46%;
}
.kolumny:first-child{
  margin-left:2%;
  margin-right:4%
}
.md-dialog-title {
    margin-bottom: 10px;
    padding: 0px 36px 0;
}
div.md-dialog {
  background: rgba(0,0,0,0.6);
}
div.form-grupa {
  width:100%;
  margin-bottom: 8px;
  height: 52px;
}
div.form-grupa label {
  width:100%;padding: 0px 4px;
}
.form-check {
width: 100%;
text-align: right;
margin-right: 50px;
position: relative;
right: 40px;
bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DaneAdresowe.vue